import { manageStatusesDtoToModel } from './utils';
import { ENUMS } from './wiki';
import { _types } from './_types';

export const actions = {
  setCurrentMode({ commit }, mode = ENUMS.MODE.request) {
    commit(_types.SET_CURRENT_MODE, { mode });
  },

  setCurrentStatus({ commit, getters, state, rootState }, status) {
    if (status?.id) {
      commit(_types.SET_CURRENT_STATUS, { status });
      commit(_types.SET_TABS_STATE, {
        config: getters.currentConfig,
        userRole: rootState?.userProfile?.profile?.role?.trim(),
      });
      commit(_types.SET_APPROVAL_NOTIFIED_INFO, null);
      if (state.mode === 'management') {
        commit(_types.SET_CURRENT_TAB, { tab: state.tabsState.activeTab });
      }
    }
  },

  setCurrentStatusTarget({ commit, getters, rootState }, statusTarget) {
    commit(_types.SET_CURRENT_STATUS_TARGET, { statusTarget });
    commit(_types.SET_TABS_STATE, {
      config: getters.currentConfig,
      userRole: rootState?.userProfile?.profile?.role?.trim(),
    });
  },

  setStatusTargets({ commit }, statusTargets) {
    if (!statusTargets) return;
    const _statusTargets = statusTargets?.map(manageStatusesDtoToModel);
    commit(_types.SET_STATUS_TARGETS, { statusTargets: _statusTargets });
  },

  setCurrentTab({ commit }, tab) {
    commit(_types.SET_CURRENT_TAB, { tab });
  },

  setApprovalNotifiedInfo({ commit }, info) {
    commit(_types.SET_APPROVAL_NOTIFIED_INFO, info);
  },

  setCurrentRequestTypeId({ commit }, requestTypeId) {
    commit(_types.SET_CURRENT_REQUEST_TYPE_ID, requestTypeId);
  },
};
